/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IBusinessSignUpItem, IBusinessSignUpViewProps } from '@msdyn365-commerce-modules/business-account-management/src/modules/business-sign-up/./business-sign-up';
import { IBusinessSignUpResources } from '../definition-extensions/business-sign-up.ext.props.autogenerated';

interface IBusinessSignUpItemWithResources extends IBusinessSignUpItem {
    inputId?: string;
    resources?: IBusinessSignUpResources;
}

const BusinessSignUpItem: React.FC<IBusinessSignUpItemWithResources> = ({
    errorMessage,
    inputId,
    input,
    isAddressInput,
    label,
    resources,
    wrapper
}) => {
    let firstChild = isAddressInput ? React.cloneElement(React.Children.toArray((input as React.ReactElement).props.children)[0], {
        isRequired: true
    }) : undefined;
    let inputNew = input;

    if (isAddressInput && firstChild) {
        inputNew = React.cloneElement(input as React.ReactElement, undefined, [firstChild]);
    }

    if (inputId === 'Department') {
        inputNew = React.cloneElement(input as React.ReactElement, {
            isRequired: true
        });
    }

    // Hide label and error message if rendering address section
    return (
        <Node {...wrapper} style={{ display: inputId === 'ProspectType' ? 'none' : undefined }}>
            {!isAddressInput && (
                inputId === 'Department'
                    ? React.cloneElement(label as React.ReactElement,{ text: resources?.organizationIdLabel })
                    : label
            )}
            {!isAddressInput && errorMessage}
            {inputNew}
        </Node>
    );
};

const validateDepartmentAddressAnd = (props: IBusinessSignUpViewProps) => {
    if (!window || !window.document) {
        return false;
    }

    const department = document.getElementById('Department') as HTMLInputElement | undefined;
    const street = document.getElementById('company_addressstreet') as HTMLInputElement | undefined;
    const zipCode = document.getElementById('company_addresszipcode')  as HTMLInputElement | undefined;
    const city = document.getElementById('company_addresscity')  as HTMLInputElement | undefined;
    const phone = document.getElementById('company_addressphone')  as HTMLInputElement | undefined;

    return department?.value && street?.value && zipCode?.value && city?.value && phone?.value;
};

const BusinesSignUpView: React.FC<IBusinessSignUpViewProps> = props => {
    const { businessSignUp, ContainerWrapper, heading, businessSignUpForm } = props;

    const { FormWrapper, buttons, items, errorMessage, disclaimer } = businessSignUpForm;

    React.useEffect(() => {
        // Auto check the buyer radio button
        if ((document.querySelector('#ProspectType-buyer') as HTMLInputElement)) {
            (document.querySelector('#ProspectType-buyer') as HTMLInputElement).click();
        }
    }, []);

    const validDepartmentAddressAnd = validateDepartmentAddressAnd(props);

    return (
        <Module {...businessSignUp}>
            <Node {...ContainerWrapper}>
                {heading}
                <Node {...FormWrapper}>
                    {items &&
                        items.map((item: IBusinessSignUpItem) => {
                            return <BusinessSignUpItem key={item.id} {...item} {...props} inputId={item.id} />;
                        })}
                    {errorMessage &&
                        errorMessage.map((error: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{error}</React.Fragment>;
                        })}
                    {buttons &&
                        buttons.map((button: React.ReactNode, index: number) => {
                            let newButton = button;
                            if ((button as React.ReactElement).key === 'continue') {
                                const isDisabled = (button as React.ReactElement).props.disabled || !validDepartmentAddressAnd;
                                newButton = React.cloneElement(button as React.ReactElement, {
                                    disabled: isDisabled
                                });
                            }
                            return <React.Fragment key={index}>{newButton}</React.Fragment>;
                        })}
                    {disclaimer}
                </Node>
            </Node>
        </Module>
    );
};

export default BusinesSignUpView;
